<template>
  <div>
    <sc-form
      autocomplete="off"
      ref="configSysnodeForm">

        <template slot="fields" slot-scope="{ fields }">
          <div class="mainContent">
            <div v-if="!isEdit" class="mainContent__paragraphs">
              <p>Nessa etapa, você irá configurar a forma de envio dos seus pedidos para a transportadora</p>
            </div>
            <div class="mainContent__table">
              <sc-warehouses-list ref="warehouseList" v-if="is_per_warehouse" :hasConfiguration="true" />
              <div class="mainContent__inputs" v-if="formFields">
                <div class="mainContent__labels">
                  <label for="status_to_send">
                    Status para enviar pedido (PLP)
                    <sc-tooltip
                      type="is-light"
                      position="is-left"
                      label="Status do TMS"
                    >
                      <sc-icon size="is-small" icon="info-circle" />
                    </sc-tooltip>
                  </label>

                  <label for="status_after">
                    Status após o envio
                    <sc-tooltip
                      type="is-light"
                      position="is-left"
                      label="Status do TMS"
                    >
                      <sc-icon size="is-small" icon="info-circle" />
                    </sc-tooltip>
                  </label>

                  <label for="psl_trigger_selected">
                    Opção de envio
                    <sc-tooltip
                      type="is-light"
                      position="is-left"
                      label="Na criação do pedido"
                    >
                      <sc-icon size="is-small" icon="info-circle" />
                    </sc-tooltip>
                  </label>

                  <div class="mainContent__inputs__field" v-if="formFields && formFields.psl_trigger_selected === 'cut_times'">
                    <label for="psl_trigger_cut_times">
                      Horários de envio
                    </label>

                    <sc-tooltip
                      type="is-light"
                      position="is-left"
                      label="Janela de envio"
                    >
                      <sc-icon size="is-small" icon="info-circle" />
                    </sc-tooltip>
                  </div>
                </div>

                <div class="mainContent__input">
                  <div class="editable">
                    <sc-multiple-selection
                      :hasActions="false"
                      :options="status_to_send_options"
                      v-model="formFields.status_to_send"
                      :disabled="disable_flags.status_to_send"
                    >
                    </sc-multiple-selection>

                    <sc-button icon="pen" theme="default" size="small"
                      v-if="disable_flags.status_to_send"
                      @click="showConfirmationDialog('status_to_send')"
                    />
                  </div>

                  <div class="editable">
                    <sc-select class="span__select" v-model="formFields.status_after" :disabled="disable_flags.status_after">
                      <option v-for="status in status_after_options" :key="status.id" :value="status.value">
                        {{ status.label }}
                      </option>
                    </sc-select>

                    <sc-button icon="pen" theme="default" size="small"
                      v-if="disable_flags.status_after"
                      @click="showConfirmationDialog('status_after')"
                    />
                  </div>

                  <div class="editable">
                    <sc-select class="span__select" v-model="formFields.psl_trigger_selected" :disabled="disable_flags.psl_trigger_selected">
                      <option  v-for="status in psl_trigger_selected_options" :key="status.id" :value="status.value">
                        {{ status.label }}
                      </option>
                    </sc-select>

                    <sc-button icon="pen" theme="default" size="small"
                      v-if="disable_flags.psl_trigger_selected"
                      @click="showConfirmationDialog('psl_trigger_selected')"
                    />
                  </div>

                  <div class="mainContent__inputs__field" v-if="formFields && formFields.psl_trigger_selected === 'cut_times'">
                    <sc-multiple-selection
                      :hasActions="false"
                      :options="psl_trigger_cut_times_options"
                      v-model="formFields.psl_trigger_cut_times"
                      :disabled="disable_flags.psl_trigger_cut_times"
                    >
                    </sc-multiple-selection>

                    <sc-button icon="pen" theme="default" size="small"
                      v-if="disable_flags.psl_trigger_cut_times"
                      @click="showConfirmationDialog('psl_trigger_cut_times')"
                    />
                  </div>
                </div>
              </div>
            </div>
           
          </div>
          <help-button/>
        </template>

        <template slot="actions" slot-scope="{ isValid }">

          <div v-if="isEdit" class="editButtons">
            <sc-button
            class="startIntegration"
            text="Cancelar"
            theme="primary"
            />

            <sc-button
            class="startIntegration"
            text="Salvar"
            theme="primary"
            />
          </div>

          <div v-else>
            <sc-button
              text="Voltar"
              theme="default"
              type="button"
              @click="backStep()"/>
            <sc-button
              text="Próximo"
              theme="primary"
              type="button"
              @click="navigateNext"/>
          </div>
        </template>
      </sc-form>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScButton,
    ScForm,
    ScField,
    ScInput,
    ScToast,
    ScTooltip,
    ScIcon,
    ScSelect,
    ScMultipleSelection,
    ScDialog,
  } from '@intelipost-js/secure-components';
  import ScWarehousesList from '../sc-warehouses-list/ScWarehousesList.vue';
  import HelpButton from '../help-button/HelpButton.vue';

  const { mapState, mapMutations } = createNamespacedHelpers('integrations/integrationsStep');

  export default {
    name: 'sc-config-sysnode',
    props: {
      isEdit: {
        type: Boolean,
        required: true,
        default: false,
      },
    },
    components: {
      ScButton,
      ScForm,
      ScField,
      ScInput,
      ScToast,
      ScTooltip,
      ScIcon,
      ScSelect,
      ScMultipleSelection,
      ScDialog,
      HelpButton,
      ScWarehousesList,
    },

    data() {
      return {
        disable_flags: {
          status_to_send: true,
          status_after: true,
          psl_trigger_selected: true,
          psl_trigger_cut_times: false,
        },
        status_to_send_options: [
          {
            value: 1,
            label: '1 - Criado',
          },
          {
            value: 6,
            label: '6 - Etiqueta Criada',
          },
          {
            value: 8,
            label: '8 - Pronto para Despacho',
          },
          {
            value: 9,
            label: '9 - Despachado',
          },
        ],

        status_after_options: [
          {
            value: 8,
            label: '8 - Pronto para Despacho',
          },
          {
            value: 9,
            label: '9 - Despachado',
          },
        ],
        psl_trigger_selected_options: [
          {
            value: '',
            label: 'Na criação do pedido',
          },
          {
            value: 'cut_times',
            label: 'Em horários específicos',
          },
        ],
        psl_trigger_cut_times_options: [
          {
            value: '08:00', label: '08:00',
          },
          {
            value: '09:00', label: '09:00',
          },
        ],
        formFields: null,
        is_per_warehouse: false,
        per_warehouse: [],
      };
    },
    computed: {
      ...mapState([
        'activeStep',
        'appDetails',
        'appConfigV2',
      ]),
    },
    mounted() {
      this.is_per_warehouse = JSON.parse(this.appDetails.app.schemaBased).is_per_warehouse;

      if (this.is_per_warehouse) {
        this.$root.$on('add-warehouse', warehouse => this.onAddWarehouse(warehouse));
        this.$root.$on('select-warehouse', warehouse => this.onSelectWarehouse(warehouse));
        this.$root.$on('remove-warehouse', warehouse => this.onRemoveWarehouse(warehouse));
      } else {
        this.formFields = {
          status_to_send: [1, 8, 9],
          status_after: 9,
          psl_trigger_selected: '',
          psl_trigger_cut_times: [],
        };
      }
    },
    methods: {
      ...mapMutations([
        'nextStep',
        'backStep',
        'setAppConfigV2',
      ]),

      mapAppConfig(oldFormat) {
        return {
          psl_volume_states_to_send: oldFormat.status_to_send.join(', '),
          psl_volume_state_after_sent: oldFormat.status_after,
          psl_trigger_cut_times: oldFormat.psl_trigger_cut_times.join(', '),
          psl_trigger_selected: oldFormat.psl_trigger_selected,
        };
      },

      navigateNext() {
        if (this.is_per_warehouse) {
          const perWarehouseMapped = this.per_warehouse.map(oldFormat => ({
            warehouse_id: oldFormat.warehouse_id,
            ...this.mapAppConfig(oldFormat),
          }));
          this.setAppConfigV2({ per_warehouse: perWarehouseMapped });
        } else {
          this.setAppConfigV2(this.mapAppConfig(this.formFields));
        }
        this.nextStep();
      },

      showConfirmationDialog(disableFlagName) {
        ScDialog.confirm({
          title: 'Confirmação',
          message: 'Estes valores são recomendados pela Intelipost. Tem certeza que deseja alterar?',
          confirmText: 'Sim, desejo alterar',
          type: 'is-danger',
          hasIcon: true,
          icon: 'times-circle',
          onConfirm: () => {
            this.disable_flags[disableFlagName] = false;
          },
        });
      },

      onRemoveWarehouse(warehouse) {
        this.per_warehouse = this.per_warehouse
          .filter(warehouseConfig => warehouseConfig.warehouse_id !== warehouse.id);
        this.formFields = null;
      },

      onAddWarehouse(warehouse) {
        this.per_warehouse.push({
          warehouse_id: warehouse.id,
          status_to_send: [1, 8, 9],
          status_after: 9,
          psl_trigger_selected: '',
          psl_trigger_cut_times: [],
        });
      },
      onSelectWarehouse(warehouse) {
        this.formFields = this.per_warehouse
          .find(warehouseConfig => warehouseConfig.warehouse_id === warehouse.id);
      },
    },
  };
</script>

<style lang='scss' scoped>
.mainContent {
  display: flex;
  flex-direction: column;
  gap: 40px;

  &__paragraphs {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__labels {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__input {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__inputs {
    display: flex;
    gap: 30px;
    max-width: 600px;
    height: 220px;
  }

  &__table {
    display: flex;
    gap: 40px;
  }


  .editable {
    display: flex;
    align-items: center;
    justify-content: center;

    & > :first-child {
      flex-grow: 1;
    }
  }
}
</style>

<style lang='scss'>
  .span__select {
    & > span {
      min-width: 100%;
    }

    & select {
      min-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-config-sysnode/ScConfigSysnode.vue?e9ecd6e8